export interface Ortaggio {
  id: number;
  nome: string;
  tipo: "da frutto" | "da foglia" | "da radice" | "legumi" | "aromatiche";
  difficolta: "facile" | "media" | "difficile";
  semina: {
    semenzaio?: { centro: string; nord: string; sud: string };
    campAperto?: { centro: string; nord: string; sud: string };
    trapianto?: { centro: string; nord: string; sud: string };
  };
  lunaConsigliata: {
    fase: "crescente" | "calante";
    motivo: string;
  };
  profondita: string;
  distanza: {
    traPiante: string;
    traFile: string;
  };
  temperatura: {
    germinazione: { min: string; ottimale: string };
    crescita?: { min: string; ottimale: string };
  };
  tempoGerminazione: string;
  terreno: string;
  raccolta: string;
  consigli: string[];
  icona: string;
  mesiSemina: number[]; // 1-12
  mesiRaccolta: number[]; // 1-12
}

export const ortaggi: Ortaggio[] = [
  {
    id: 1,
    nome: "Pomodoro",
    tipo: "da frutto",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "febbraio-marzo", nord: "marzo-aprile", sud: "gennaio-marzo" },
      campAperto: { centro: "aprile-maggio", nord: "maggio-giugno", sud: "marzo-aprile" },
      trapianto: { centro: "aprile-giugno", nord: "maggio-giugno", sud: "marzo-maggio" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce lo sviluppo della parte aerea e dei frutti"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "40-50 cm", traFile: "70-100 cm" },
    temperatura: {
      germinazione: { min: "13°C", ottimale: "20-25°C" },
      crescita: { min: "15°C", ottimale: "20-25°C" }
    },
    tempoGerminazione: "7-14 giorni",
    terreno: "Fertile, ben drenato, ricco di sostanza organica, pH 6-7",
    raccolta: "90-120 giorni dal trapianto (luglio-ottobre)",
    consigli: [
      "Richiede tutori o sostegni per la crescita",
      "Eliminare i getti ascellari per favorire la produzione",
      "Annaffiare regolarmente evitando di bagnare le foglie",
      "Necessita di pieno sole (almeno 6-8 ore al giorno)"
    ],
    icona: "🍅",
    mesiSemina: [2, 3, 4],
    mesiRaccolta: [7, 8, 9]
  },
  {
    id: 2,
    nome: "Peperone",
    tipo: "da frutto",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "febbraio-marzo", nord: "marzo-aprile", sud: "gennaio-febbraio" },
      trapianto: { centro: "aprile-maggio", nord: "maggio-giugno", sud: "marzo-aprile" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce lo sviluppo dei frutti e della parte aerea"
    },
    profondita: "0.5 cm",
    distanza: { traPiante: "40-50 cm", traFile: "60-70 cm" },
    temperatura: {
      germinazione: { min: "15°C", ottimale: "25-28°C" },
      crescita: { min: "18°C", ottimale: "20-26°C" }
    },
    tempoGerminazione: "10-15 giorni",
    terreno: "Fertile, sciolto, ben drenato, ricco di humus, pH 6-6.8",
    raccolta: "100-130 giorni dal trapianto (luglio-ottobre)",
    consigli: [
      "Sensibile al freddo, non trapiantare prima che le temperature siano stabili",
      "Necessita di irrigazioni regolari",
      "Concimare ogni 2-3 settimane durante la crescita",
      "Raccogliere quando i frutti sono completamente colorati"
    ],
    icona: "🌶️",
    mesiSemina: [2, 4],
    mesiRaccolta: [7, 8, 9]
  },
  {
    id: 3,
    nome: "Melanzana",
    tipo: "da frutto",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "febbraio-marzo", nord: "marzo-aprile", sud: "gennaio-marzo" },
      trapianto: { centro: "aprile-maggio", nord: "maggio", sud: "marzo-aprile" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce la fruttificazione e lo sviluppo vegetativo"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "50-60 cm", traFile: "80-100 cm" },
    temperatura: {
      germinazione: { min: "15°C", ottimale: "24-26°C" },
      crescita: { min: "18°C", ottimale: "22-28°C" }
    },
    tempoGerminazione: "10-15 giorni",
    terreno: "Fertile, profondo, ben drenato, ricco di sostanza organica, pH 6-7",
    raccolta: "110-140 giorni dal trapianto (luglio-ottobre)",
    consigli: [
      "Molto esigente di calore",
      "Richiede abbondanti annaffiature",
      "Cimare la pianta per favorire la produzione",
      "Proteggere dal vento"
    ],
    icona: "🍆",
    mesiSemina: [2, 4],
    mesiRaccolta: [7, 8, 9]
  },
  {
    id: 4,
    nome: "Zucchina",
    tipo: "da frutto",
    difficolta: "facile",
    semina: {
      semenzaio: { centro: "marzo-aprile", nord: "aprile", sud: "febbraio-marzo" },
      campAperto: { centro: "aprile-giugno", nord: "maggio-giugno", sud: "marzo-maggio" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce lo sviluppo dei frutti"
    },
    profondita: "2-3 cm",
    distanza: { traPiante: "80-100 cm", traFile: "100-120 cm" },
    temperatura: {
      germinazione: { min: "12°C", ottimale: "20-25°C" }
    },
    tempoGerminazione: "5-8 giorni",
    terreno: "Fertile, sciolto, ben drenato, ricco di sostanza organica, pH 6-7",
    raccolta: "45-60 giorni dalla semina (giugno-ottobre)",
    consigli: [
      "Raccogliere i frutti giovani e teneri",
      "Annaffiare regolarmente evitando ristagni",
      "Necessita di spazio per lo sviluppo",
      "Eliminare foglie vecchie per prevenire malattie"
    ],
    icona: "🥒",
    mesiSemina: [3, 5],
    mesiRaccolta: [6, 7, 8, 9]
  },
  {
    id: 5,
    nome: "Lattuga",
    tipo: "da foglia",
    difficolta: "facile",
    semina: {
      semenzaio: { centro: "febbraio-aprile, agosto-settembre", nord: "marzo-aprile, agosto", sud: "gennaio-aprile, settembre-ottobre" },
      campAperto: { centro: "marzo-settembre", nord: "aprile-agosto", sud: "febbraio-ottobre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Evita la prefioritura precoce e favorisce la formazione del cespo"
    },
    profondita: "0.5 cm",
    distanza: { traPiante: "25-30 cm", traFile: "30-35 cm" },
    temperatura: {
      germinazione: { min: "5°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "5-10 giorni",
    terreno: "Fertile, fresco, ben drenato, ricco di sostanza organica, pH 6-7",
    raccolta: "40-80 giorni dalla semina a seconda della varietà",
    consigli: [
      "Semina scalare ogni 2-3 settimane per raccolto continuo",
      "Non sopporta il caldo eccessivo",
      "Annaffiature frequenti ma moderate",
      "Raccogliere al mattino presto"
    ],
    icona: "🥬",
    mesiSemina: [1, 3, 4, 5, 6, 7, 8],
    mesiRaccolta: [5, 10, 11]
  },
  {
    id: 6,
    nome: "Spinacio",
    tipo: "da foglia",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "febbraio-aprile, settembre-ottobre", nord: "marzo-aprile, agosto-settembre", sud: "gennaio-aprile, settembre-novembre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Ritarda la montata a seme e favorisce lo sviluppo fogliare"
    },
    profondita: "1-2 cm",
    distanza: { traPiante: "8-10 cm", traFile: "25-30 cm" },
    temperatura: {
      germinazione: { min: "4°C", ottimale: "10-15°C" }
    },
    tempoGerminazione: "7-14 giorni",
    terreno: "Fertile, fresco, ben drenato, ricco di azoto, pH 6.5-7.5",
    raccolta: "40-60 giorni dalla semina",
    consigli: [
      "Resiste bene al freddo",
      "Evitare temperature troppo alte che causano fioritura",
      "Semina fitta per foglie tenere",
      "Annaffiature regolari"
    ],
    icona: "🌿",
    mesiSemina: [2, 8],
    mesiRaccolta: [4, 5, 10, 11]
  },
  {
    id: 7,
    nome: "Carota",
    tipo: "da radice",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "febbraio-luglio", nord: "marzo-giugno", sud: "gennaio-agosto" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce lo sviluppo della radice"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "5-8 cm", traFile: "25-30 cm" },
    temperatura: {
      germinazione: { min: "8°C", ottimale: "18-20°C" }
    },
    tempoGerminazione: "10-20 giorni",
    terreno: "Sciolto, sabbioso, profondo, ben drenato, senza pietre, pH 6-7",
    raccolta: "90-120 giorni dalla semina",
    consigli: [
      "Terreno ben lavorato e soffice è essenziale",
      "Non concimare con letame fresco",
      "Diradare le piantine dopo la germinazione",
      "Annaffiature regolari per evitare spaccature"
    ],
    icona: "🥕",
    mesiSemina: [3, 4, 5, 6, 7],
    mesiRaccolta: [6, 9, 10, 11]
  },
  {
    id: 8,
    nome: "Ravanello",
    tipo: "da radice",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "febbraio-ottobre", nord: "marzo-settembre", sud: "gennaio-novembre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce lo sviluppo della radice e la tenerezza"
    },
    profondita: "1 cm",
    distanza: { traPiante: "3-5 cm", traFile: "15-20 cm" },
    temperatura: {
      germinazione: { min: "6°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "3-7 giorni",
    terreno: "Sciolto, fertile, ben drenato, fresco, pH 6-7",
    raccolta: "20-40 giorni dalla semina",
    consigli: [
      "Crescita rapidissima, ideale per principianti",
      "Semina scalare ogni 10 giorni",
      "Raccogliere quando ancora teneri",
      "Annaffiature frequenti"
    ],
    icona: "🌱",
    mesiSemina: [1, 2, 3, 8],
    mesiRaccolta: [4, 10, 11]
  },
  {
    id: 9,
    nome: "Cipolla",
    tipo: "da radice",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "gennaio-febbraio", nord: "febbraio-marzo", sud: "dicembre-gennaio" },
      campAperto: { centro: "febbraio-marzo, settembre", nord: "marzo-aprile", sud: "gennaio-marzo, settembre-ottobre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce lo sviluppo del bulbo"
    },
    profondita: "1-2 cm",
    distanza: { traPiante: "10-15 cm", traFile: "25-30 cm" },
    temperatura: {
      germinazione: { min: "7°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "10-15 giorni",
    terreno: "Sciolto, fertile, ben drenato, non acido, pH 6-7",
    raccolta: "120-180 giorni dalla semina",
    consigli: [
      "Evitare ristagni d'acqua",
      "Non interrare troppo profondamente",
      "Raccogliere quando le foglie si piegano",
      "Far asciugare prima di conservare"
    ],
    icona: "🧅",
    mesiSemina: [2, 11, 12],
    mesiRaccolta: [6]
  },
  {
    id: 10,
    nome: "Fagiolo",
    tipo: "legumi",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "aprile-luglio", nord: "maggio-giugno", sud: "marzo-luglio" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce la germinazione e la produzione di baccelli"
    },
    profondita: "3-4 cm",
    distanza: { traPiante: "10-15 cm (nani) / 30-40 cm (rampicanti)", traFile: "50-70 cm" },
    temperatura: {
      germinazione: { min: "12°C", ottimale: "20-25°C" }
    },
    tempoGerminazione: "5-10 giorni",
    terreno: "Medio impasto, ben drenato, non troppo ricco di azoto, pH 6-7",
    raccolta: "60-90 giorni dalla semina",
    consigli: [
      "I fagioli rampicanti necessitano di sostegni",
      "Non annaffiare durante la fioritura",
      "Raccogliere regolarmente per stimolare produzione",
      "Arricchiscono il terreno di azoto"
    ],
    icona: "🌱",
    mesiSemina: [4, 7, 8],
    mesiRaccolta: [10]
  },
  {
    id: 11,
    nome: "Pisello",
    tipo: "legumi",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "febbraio-aprile, settembre-ottobre", nord: "marzo-aprile", sud: "gennaio-aprile, ottobre-novembre" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce la germinazione e la produzione di baccelli"
    },
    profondita: "3-5 cm",
    distanza: { traPiante: "5-8 cm", traFile: "40-60 cm" },
    temperatura: {
      germinazione: { min: "5°C", ottimale: "15-18°C" }
    },
    tempoGerminazione: "7-14 giorni",
    terreno: "Medio impasto, ben drenato, calcareo, pH 6.5-7.5",
    raccolta: "90-120 giorni dalla semina",
    consigli: [
      "Resiste bene al freddo",
      "I piselli rampicanti necessitano di sostegni",
      "Raccogliere i baccelli quando sono turgidi",
      "Migliorano la fertilità del terreno"
    ],
    icona: "🌿",
    mesiSemina: [2, 4, 9, 11],
    mesiRaccolta: [5]
  },
  {
    id: 12,
    nome: "Basilico",
    tipo: "aromatiche",
    difficolta: "facile",
    semina: {
      semenzaio: { centro: "marzo-aprile", nord: "aprile", sud: "febbraio-marzo" },
      campAperto: { centro: "aprile-giugno", nord: "maggio-giugno", sud: "marzo-giugno" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce lo sviluppo fogliare e l'aroma"
    },
    profondita: "0.5 cm",
    distanza: { traPiante: "20-25 cm", traFile: "30 cm" },
    temperatura: {
      germinazione: { min: "15°C", ottimale: "20-25°C" }
    },
    tempoGerminazione: "5-10 giorni",
    terreno: "Fertile, sciolto, ben drenato, ricco di sostanza organica, pH 6-7",
    raccolta: "40-60 giorni dalla semina (continua)",
    consigli: [
      "Sensibile al freddo, non esporre a temperature sotto 10°C",
      "Cimare regolarmente per favorire cespugliatura",
      "Annaffiature regolari, terreno sempre umido",
      "Raccogliere le foglie prima della fioritura"
    ],
    icona: "🌿",
    mesiSemina: [3, 4, 5, 6, 7],
    mesiRaccolta: [8, 9]
  },
  {
    id: 13,
    nome: "Prezzemolo",
    tipo: "aromatiche",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "marzo-settembre", nord: "aprile-agosto", sud: "febbraio-ottobre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce lo sviluppo fogliare e ritarda la fioritura"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "15-20 cm", traFile: "25-30 cm" },
    temperatura: {
      germinazione: { min: "8°C", ottimale: "18-22°C" }
    },
    tempoGerminazione: "15-25 giorni",
    terreno: "Fertile, fresco, ben drenato, ricco di sostanza organica, pH 6-7",
    raccolta: "70-90 giorni dalla semina (continua)",
    consigli: [
      "Germinazione lenta, ammollare i semi 24h prima",
      "Posizione semi-ombreggiata in estate",
      "Annaffiature regolari",
      "Raccogliere le foglie esterne"
    ],
    icona: "🌱",
    mesiSemina: [2, 3, 5, 6, 10],
    mesiRaccolta: [10, 11, 12]
  },
  {
    id: 14,
    nome: "Rucola",
    tipo: "da foglia",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "febbraio-ottobre", nord: "marzo-settembre", sud: "gennaio-novembre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Ritarda la fioritura e mantiene le foglie tenere"
    },
    profondita: "0.5 cm",
    distanza: { traPiante: "10-15 cm", traFile: "20-25 cm" },
    temperatura: {
      germinazione: { min: "5°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "5-7 giorni",
    terreno: "Fertile, fresco, ben drenato, pH 6-7",
    raccolta: "30-40 giorni dalla semina",
    consigli: [
      "Crescita rapidissima",
      "Semina scalare ogni 2 settimane",
      "In estate preferisce mezz'ombra",
      "Tagliare lasciando la base per ricaccio"
    ],
    icona: "🥗",
    mesiSemina: [1],
    mesiRaccolta: []
  },
  {
    id: 15,
    nome: "Zucca",
    tipo: "da frutto",
    difficolta: "facile",
    semina: {
      semenzaio: { centro: "marzo-aprile", nord: "aprile", sud: "febbraio-marzo" },
      campAperto: { centro: "aprile-giugno", nord: "maggio-giugno", sud: "marzo-maggio" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce lo sviluppo dei frutti voluminosi"
    },
    profondita: "2-3 cm",
    distanza: { traPiante: "100-150 cm", traFile: "150-200 cm" },
    temperatura: {
      germinazione: { min: "15°C", ottimale: "25-30°C" }
    },
    tempoGerminazione: "5-10 giorni",
    terreno: "Fertile, profondo, ricco di sostanza organica, ben drenato, pH 6-7",
    raccolta: "100-140 giorni dalla semina (settembre-novembre)",
    consigli: [
      "Necessita di molto spazio",
      "Annaffiature abbondanti durante la crescita",
      "Concimare generosamente",
      "Raccogliere quando il picciolo è secco"
    ],
    icona: "🎃",
    mesiSemina: [3, 4, 5],
    mesiRaccolta: [9, 10, 11]
  },
  {
    id: 16,
    nome: "Cetriolo",
    tipo: "da frutto",
    difficolta: "facile",
    semina: {
      semenzaio: { centro: "marzo-aprile", nord: "aprile", sud: "febbraio-marzo" },
      campAperto: { centro: "aprile-giugno", nord: "maggio-giugno", sud: "marzo-maggio" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce la produzione di frutti"
    },
    profondita: "1-2 cm",
    distanza: { traPiante: "40-50 cm", traFile: "100-120 cm" },
    temperatura: {
      germinazione: { min: "15°C", ottimale: "25-30°C" }
    },
    tempoGerminazione: "5-10 giorni",
    terreno: "Fertile, sciolto, ricco di sostanza organica, ben drenato, pH 6-7",
    raccolta: "50-70 giorni dalla semina (giugno-settembre)",
    consigli: [
      "Necessita di supporti per varietà rampicanti",
      "Raccogliere frutti giovani e teneri",
      "Annaffiature abbondanti e regolari",
      "Proteggere dalle basse temperature"
    ],
    icona: "🥒",
    mesiSemina: [3, 4, 5, 6],
    mesiRaccolta: [7, 8, 9, 10]
  },
  {
    id: 17,
    nome: "Melone",
    tipo: "da frutto",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "marzo-aprile", nord: "aprile", sud: "febbraio-marzo" },
      campAperto: { centro: "aprile-maggio", nord: "maggio", sud: "marzo-aprile" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce dolcezza e dimensione dei frutti"
    },
    profondita: "2-3 cm",
    distanza: { traPiante: "80-100 cm", traFile: "120-150 cm" },
    temperatura: {
      germinazione: { min: "15°C", ottimale: "25-30°C" }
    },
    tempoGerminazione: "5-8 giorni",
    terreno: "Sciolto, fertile, sabbioso, ben drenato, ricco di potassio, pH 6-7",
    raccolta: "80-120 giorni dalla semina (luglio-settembre)",
    consigli: [
      "Necessita di calore costante",
      "Ridurre annaffiature durante maturazione per dolcezza",
      "Cimare dopo 4-5 foglie",
      "Raccogliere quando il frutto si stacca facilmente"
    ],
    icona: "🍈",
    mesiSemina: [3, 4],
    mesiRaccolta: [7, 8, 9]
  },
  {
    id: 18,
    nome: "Anguria",
    tipo: "da frutto",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "marzo-aprile", nord: "aprile", sud: "febbraio-marzo" },
      campAperto: { centro: "aprile-maggio", nord: "maggio", sud: "marzo-aprile" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce dimensione e succosità dei frutti"
    },
    profondita: "2-3 cm",
    distanza: { traPiante: "100-150 cm", traFile: "150-200 cm" },
    temperatura: {
      germinazione: { min: "18°C", ottimale: "25-30°C" }
    },
    tempoGerminazione: "5-10 giorni",
    terreno: "Sciolto, sabbioso, fertile, ben drenato, ricco di potassio, pH 6-6.8",
    raccolta: "90-120 giorni dalla semina (luglio-settembre)",
    consigli: [
      "Necessita di molto spazio e calore",
      "Annaffiature abbondanti durante crescita",
      "Ridurre acqua durante maturazione",
      "Raccogliere quando il cirro si secca"
    ],
    icona: "🍉",
    mesiSemina: [3, 4],
    mesiRaccolta: [7, 8]
  },
  {
    id: 19,
    nome: "Cavolo nero",
    tipo: "da foglia",
    difficolta: "facile",
    semina: {
      semenzaio: { centro: "maggio-luglio", nord: "giugno-luglio", sud: "maggio-agosto" },
      campAperto: { centro: "giugno-agosto", nord: "luglio", sud: "giugno-settembre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce compattezza e qualità delle foglie"
    },
    profondita: "1 cm",
    distanza: { traPiante: "40-50 cm", traFile: "50-60 cm" },
    temperatura: {
      germinazione: { min: "7°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "5-10 giorni",
    terreno: "Fertile, compatto, ricco di sostanza organica, pH 6.5-7.5",
    raccolta: "90-120 giorni dal trapianto (ottobre-marzo)",
    consigli: [
      "Resiste molto bene al freddo",
      "Il gelo migliora il sapore",
      "Raccogliere le foglie esterne",
      "Annaffiature regolari"
    ],
    icona: "🥬",
    mesiSemina: [],
    mesiRaccolta: []
  },
  {
    id: 20,
    nome: "Cavolfiore",
    tipo: "da foglia",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "maggio-luglio", nord: "giugno", sud: "luglio-agosto" },
      trapianto: { centro: "luglio-settembre", nord: "agosto", sud: "settembre-ottobre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce la formazione compatta della testa"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "50-60 cm", traFile: "60-70 cm" },
    temperatura: {
      germinazione: { min: "10°C", ottimale: "18-20°C" }
    },
    tempoGerminazione: "5-10 giorni",
    terreno: "Fertile, profondo, ricco di sostanza organica, pH 6.5-7.5",
    raccolta: "90-150 giorni dal trapianto",
    consigli: [
      "Necessita di irrigazioni costanti",
      "Piegare le foglie sulla testa per mantenerla bianca",
      "Concimare abbondantemente",
      "Raccogliere quando la testa è compatta"
    ],
    icona: "🥦",
    mesiSemina: [6, 7, 8],
    mesiRaccolta: [2, 3, 10, 11, 12]
  },
  {
    id: 21,
    nome: "Broccolo",
    tipo: "da foglia",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "maggio-luglio", nord: "giugno", sud: "luglio-agosto" },
      trapianto: { centro: "luglio-settembre", nord: "agosto", sud: "settembre-ottobre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce formazione infiorescenze compatte"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "40-50 cm", traFile: "50-60 cm" },
    temperatura: {
      germinazione: { min: "10°C", ottimale: "18-20°C" }
    },
    tempoGerminazione: "5-10 giorni",
    terreno: "Fertile, ben drenato, ricco di sostanza organica, pH 6.5-7.5",
    raccolta: "80-120 giorni dal trapianto",
    consigli: [
      "Dopo raccolta testa centrale produce getti laterali",
      "Resiste bene al freddo",
      "Annaffiature regolari",
      "Raccogliere quando le cime sono compatte"
    ],
    icona: "🥦",
    mesiSemina: [],
    mesiRaccolta: []
  },
  {
    id: 22,
    nome: "Bieta",
    tipo: "da foglia",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "marzo-agosto", nord: "aprile-luglio", sud: "febbraio-settembre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce sviluppo foglie e coste tenere"
    },
    profondita: "2-3 cm",
    distanza: { traPiante: "25-30 cm", traFile: "35-40 cm" },
    temperatura: {
      germinazione: { min: "7°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "7-14 giorni",
    terreno: "Fertile, fresco, ben drenato, ricco di sostanza organica, pH 6-7.5",
    raccolta: "60-90 giorni dalla semina (continua)",
    consigli: [
      "Resistente e di facile coltivazione",
      "Raccogliere foglie esterne",
      "Annaffiature regolari",
      "Tollera bene sia caldo che freddo moderato"
    ],
    icona: "🥬",
    mesiSemina: [2, 4, 5, 6, 7],
    mesiRaccolta: [9, 10, 11]
  },
  {
    id: 23,
    nome: "Barbabietola",
    tipo: "da radice",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "marzo-luglio", nord: "aprile-giugno", sud: "febbraio-agosto" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce sviluppo radice e dolcezza"
    },
    profondita: "2-3 cm",
    distanza: { traPiante: "10-15 cm", traFile: "30-35 cm" },
    temperatura: {
      germinazione: { min: "8°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "10-15 giorni",
    terreno: "Sciolto, fertile, profondo, ben drenato, pH 6.5-7.5",
    raccolta: "90-120 giorni dalla semina",
    consigli: [
      "Diradare dopo germinazione",
      "Annaffiature regolari per tenerezza",
      "Raccogliere quando radice è 5-8 cm diametro",
      "Conserva bene dopo raccolta"
    ],
    icona: "🍠",
    mesiSemina: [2],
    mesiRaccolta: [7, 8, 9]
  },
  {
    id: 24,
    nome: "Aglio",
    tipo: "da radice",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "ottobre-dicembre, febbraio-marzo", nord: "febbraio-marzo", sud: "ottobre-febbraio" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce sviluppo bulbo e conservabilità"
    },
    profondita: "3-5 cm",
    distanza: { traPiante: "10-15 cm", traFile: "25-30 cm" },
    temperatura: {
      germinazione: { min: "0°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "15-30 giorni",
    terreno: "Sciolto, fertile, ben drenato, non umido, pH 6-7",
    raccolta: "150-180 giorni dalla semina",
    consigli: [
      "Piantagione autunnale dà bulbi più grandi",
      "Evitare ristagni d'acqua assolutamente",
      "Raccogliere quando foglie ingialliscono",
      "Far asciugare bene prima di conservare"
    ],
    icona: "🧄",
    mesiSemina: [1, 11, 12],
    mesiRaccolta: []
  },
  {
    id: 25,
    nome: "Porro",
    tipo: "da radice",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "febbraio-aprile", nord: "marzo-aprile", sud: "gennaio-marzo" },
      trapianto: { centro: "maggio-luglio", nord: "giugno-luglio", sud: "aprile-giugno" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce allungamento parte bianca"
    },
    profondita: "1 cm",
    distanza: { traPiante: "10-15 cm", traFile: "30-40 cm" },
    temperatura: {
      germinazione: { min: "10°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "10-20 giorni",
    terreno: "Fertile, profondo, fresco, ben drenato, pH 6-7",
    raccolta: "150-180 giorni dalla semina",
    consigli: [
      "Rincalzare per sbiancare il fusto",
      "Resiste molto bene al freddo",
      "Annaffiature regolari",
      "Può rimanere in terra tutto l'inverno"
    ],
    icona: "🥬",
    mesiSemina: [2, 3, 5, 6],
    mesiRaccolta: [8, 9, 10, 11, 12]
  },
  {
    id: 26,
    nome: "Finocchio",
    tipo: "da radice",
    difficolta: "media",
    semina: {
      campAperto: { centro: "giugno-agosto", nord: "luglio", sud: "luglio-settembre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Evita montata a seme e favorisce grumolo compatto"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "20-25 cm", traFile: "40-50 cm" },
    temperatura: {
      germinazione: { min: "15°C", ottimale: "18-22°C" }
    },
    tempoGerminazione: "10-15 giorni",
    terreno: "Sciolto, fertile, ben drenato, fresco, pH 6-7",
    raccolta: "90-120 giorni dalla semina",
    consigli: [
      "Semina estiva per raccolto autunnale",
      "Rincalzare per sbiancare grumolo",
      "Sensibile a sbalzi termici (va a seme)",
      "Annaffiature regolari"
    ],
    icona: "🌿",
    mesiSemina: [2, 3, 5, 6, 7],
    mesiRaccolta: [6, 9, 10, 11]
  },
  {
    id: 27,
    nome: "Fava",
    tipo: "legumi",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "ottobre-novembre, febbraio-marzo", nord: "febbraio-marzo", sud: "ottobre-dicembre" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce germinazione e produzione baccelli"
    },
    profondita: "4-5 cm",
    distanza: { traPiante: "15-20 cm", traFile: "40-50 cm" },
    temperatura: {
      germinazione: { min: "5°C", ottimale: "12-18°C" }
    },
    tempoGerminazione: "10-15 giorni",
    terreno: "Medio impasto, ben drenato, pH 6.5-7.5",
    raccolta: "120-150 giorni dalla semina",
    consigli: [
      "Molto resistente al freddo",
      "Cimare a 5-6 palchi per favorire produzione",
      "Arricchisce terreno di azoto",
      "Raccogliere baccelli ancora teneri"
    ],
    icona: "🍃",
    mesiSemina: [2, 9, 10, 11],
    mesiRaccolta: [6]
  },
  {
    id: 28,
    nome: "Peperoncino",
    tipo: "da frutto",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "febbraio-marzo", nord: "marzo-aprile", sud: "gennaio-febbraio" },
      trapianto: { centro: "aprile-maggio", nord: "maggio", sud: "marzo-aprile" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce fruttificazione e piccantezza"
    },
    profondita: "0.5 cm",
    distanza: { traPiante: "30-40 cm", traFile: "50-60 cm" },
    temperatura: {
      germinazione: { min: "18°C", ottimale: "25-28°C" }
    },
    tempoGerminazione: "10-20 giorni",
    terreno: "Sciolto, fertile, ben drenato, pH 6-6.8",
    raccolta: "90-120 giorni dal trapianto",
    consigli: [
      "Necessita di molto calore",
      "Stress idrico moderato aumenta piccantezza",
      "Può essere coltivato in vaso",
      "Raccogliere a maturazione completa per massima piccantezza"
    ],
    icona: "🌶️",
    mesiSemina: [2, 4, 8],
    mesiRaccolta: [8, 9]
  },
  {
    id: 29,
    nome: "Cicoria",
    tipo: "da foglia",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "giugno-settembre", nord: "luglio-agosto", sud: "agosto-ottobre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Evita fioritura precoce e favorisce cespo"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "25-30 cm", traFile: "30-40 cm" },
    temperatura: {
      germinazione: { min: "10°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "7-12 giorni",
    terreno: "Medio impasto, fertile, ben drenato, pH 6-7",
    raccolta: "80-120 giorni dalla semina",
    consigli: [
      "Resistente al freddo",
      "Legare le foglie per imbianchimento (opzionale)",
      "Annaffiature moderate",
      "Il freddo ne migliora sapore"
    ],
    icona: "🥬",
    mesiSemina: [1, 2, 5, 9, 10, 11],
    mesiRaccolta: [2, 3, 11, 12]
  },
  {
    id: 30,
    nome: "Radicchio",
    tipo: "da foglia",
    difficolta: "media",
    semina: {
      campAperto: { centro: "giugno-agosto", nord: "luglio", sud: "luglio-settembre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce cespo compatto e colorazione"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "25-30 cm", traFile: "30-40 cm" },
    temperatura: {
      germinazione: { min: "12°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "7-12 giorni",
    terreno: "Fertile, fresco, ben drenato, pH 6-7",
    raccolta: "90-120 giorni dalla semina",
    consigli: [
      "Il freddo favorisce colorazione rossa",
      "Alcune varietà richiedono forzatura",
      "Annaffiature regolari",
      "Raccogliere quando cespo è compatto"
    ],
    icona: "🥬",
    mesiSemina: [],
    mesiRaccolta: []
  },
  {
    id: 31,
    nome: "Valeriana",
    tipo: "da foglia",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "agosto-novembre", nord: "agosto-ottobre", sud: "settembre-dicembre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Favorisce lo sviluppo fogliare e ritarda la fioritura"
    },
    profondita: "0.5 cm",
    distanza: { traPiante: "10-15 cm", traFile: "20-25 cm" },
    temperatura: {
      germinazione: { min: "5°C", ottimale: "12-18°C" }
    },
    tempoGerminazione: "10-15 giorni",
    terreno: "Fertile, fresco, ben drenato, pH 6-7",
    raccolta: "60-90 giorni dalla semina",
    consigli: [
      "Resiste molto bene al freddo",
      "Ideale per colture autunno-invernali",
      "Annaffiature moderate",
      "Raccogliere tagliando sopra il colletto per ricaccio"
    ],
    icona: "🥬",
    mesiSemina: [1, 5, 7],
    mesiRaccolta: [9, 10, 11]
  },
  {
    id: 32,
    nome: "Sedano",
    tipo: "da foglia",
    difficolta: "media",
    semina: {
      semenzaio: { centro: "febbraio-aprile", nord: "marzo-aprile", sud: "gennaio-marzo" },
      trapianto: { centro: "aprile-giugno", nord: "maggio-giugno", sud: "marzo-maggio" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce lo sviluppo vegetativo e delle coste"
    },
    profondita: "0.5 cm",
    distanza: { traPiante: "30-35 cm", traFile: "40-50 cm" },
    temperatura: {
      germinazione: { min: "10°C", ottimale: "18-22°C" },
      crescita: { min: "15°C", ottimale: "18-22°C" }
    },
    tempoGerminazione: "15-25 giorni",
    terreno: "Fertile, profondo, fresco, ricco di sostanza organica, pH 6.5-7.5",
    raccolta: "120-150 giorni dal trapianto",
    consigli: [
      "Necessita di abbondanti annaffiature",
      "Rincalzare per sbiancare le coste",
      "Sensibile alle gelate intense",
      "Germinazione lenta e irregolare"
    ],
    icona: "🌿",
    mesiSemina: [1, 2, 5, 6],
    mesiRaccolta: [8, 9, 10]
  },
  {
    id: 33,
    nome: "Scarola",
    tipo: "da foglia",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "giugno-ottobre", nord: "luglio-settembre", sud: "agosto-novembre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Evita fioritura precoce e favorisce cespo compatto"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "30-35 cm", traFile: "35-40 cm" },
    temperatura: {
      germinazione: { min: "10°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "7-12 giorni",
    terreno: "Fertile, fresco, ben drenato, ricco di sostanza organica, pH 6-7",
    raccolta: "80-100 giorni dalla semina",
    consigli: [
      "Resiste bene al freddo",
      "Legare le foglie per imbianchimento (opzionale)",
      "Annaffiature regolari",
      "Ideale per raccolti autunno-invernali"
    ],
    icona: "🥬",
    mesiSemina: [3, 5, 6],
    mesiRaccolta: [10, 11, 12]
  },
  {
    id: 34,
    nome: "Indivia",
    tipo: "da foglia",
    difficolta: "facile",
    semina: {
      campAperto: { centro: "giugno-ottobre", nord: "luglio-settembre", sud: "agosto-novembre" }
    },
    lunaConsigliata: {
      fase: "calante",
      motivo: "Evita montata a seme e favorisce cespo"
    },
    profondita: "0.5-1 cm",
    distanza: { traPiante: "30-35 cm", traFile: "35-40 cm" },
    temperatura: {
      germinazione: { min: "10°C", ottimale: "15-20°C" }
    },
    tempoGerminazione: "7-12 giorni",
    terreno: "Fertile, fresco, ben drenato, pH 6-7",
    raccolta: "80-100 giorni dalla semina",
    consigli: [
      "Resiste molto bene al freddo",
      "Legare le foglie per imbianchimento",
      "Annaffiature moderate",
      "Il freddo migliora il sapore"
    ],
    icona: "🥬",
    mesiSemina: [4, 5, 6, 7],
    mesiRaccolta: [10, 11, 12]
  },
  {
    id: 35,
    nome: "Asparago",
    tipo: "da foglia",
    difficolta: "difficile",
    semina: {
      campAperto: { centro: "marzo-aprile", nord: "aprile", sud: "febbraio-marzo" }
    },
    lunaConsigliata: {
      fase: "crescente",
      motivo: "Favorisce lo sviluppo dei turioni"
    },
    profondita: "15-20 cm (zampe)",
    distanza: { traPiante: "30-40 cm", traFile: "100-120 cm" },
    temperatura: {
      germinazione: { min: "10°C", ottimale: "20-25°C" }
    },
    tempoGerminazione: "20-30 giorni (da seme)",
    terreno: "Sciolto, sabbioso, ben drenato, profondo, pH 6.5-7.5",
    raccolta: "Dalla terza primavera dopo l'impianto",
    consigli: [
      "Coltura pluriennale (10-15 anni)",
      "Richiede pazienza: primi raccolti dopo 2-3 anni",
      "Non raccogliere i primi due anni",
      "Concimare abbondantemente in autunno",
      "Evitare ristagni d'acqua"
    ],
    icona: "🌱",
    mesiSemina: [3],
    mesiRaccolta: [4]
  }
];
